import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";

import { CAPTCHA_SITE_KEY } from "../utils/auth/config";

/**
 * A collection of static API calls for VOE
 * @name RecaptchaDao
 */
const RecaptchaDao = (props) => {
    const { action, data } = props;

    const options = {
        headers: {
            Accept: "application/json",
            "Access-Control-Max-Age": null,
            "Content-Type": "application/json"
        }
    };

    switch (action) {
        case "verify2":
            return RecaptchaDao.verify(props);
        case "verify":
            options.data = data;
            options.method = "POST";
            options.url =
                window.location.port.toString() === "9000"
                    ? "http://localhost:8080/verifyRecaptcha"
                    : `https://${window.location.host}/verifyRecaptcha`;
            break;
        default:
            return null;
    }

    return ServiceWrapper.serviceCall({
        options,
        ...props
    });
};

/**
 * Load the google recaptcha script
 * @name loadRecaptcha
 * @static
 * @param {string} divName
 */
RecaptchaDao.loadRecaptcha = (divName) => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${CAPTCHA_SITE_KEY}`;
    if (divName === undefined) {
        document.body.appendChild(script);
    } else {
        document.getElementById(divName).appendChild(script);
    }
};

RecaptchaDao.propTypes = {
    action: PropTypes.string.isRequired,
    data: PropTypes.oneOfType([PropTypes.object])
};

RecaptchaDao.defaultProps = {
    data: null
};

export default RecaptchaDao;
